const COLOR_MODE_PREFERENCE_KEY = 'ADS-COLOR-MODE';

export const useSSRSafeThemeObserver = () => {
	try {
		const storedTheme = localStorage.getItem(COLOR_MODE_PREFERENCE_KEY);
		if (storedTheme && ['light', 'dark'].includes(storedTheme)) {
			return storedTheme;
		}
	} catch (e) {}
	// Default to dark mode if no preference is found, theme is set to auto, or local storage is not available
	return 'dark';
};
